/**
 * Build a Lookup-shaped prefill payload from operator-authored
 * `queryParamMappings` and the current page URL.
 *
 * Mappings are interpreted as "if the URL has `?ref=ABC`, seed the
 * referenceNumber form field with `ABC`". Missing params are silently
 * ignored — the form just renders empty for that field. Duplicate
 * mappings to the same field: last-one-wins.
 *
 * Pure function; no DOM access. App.tsx hands in the already-parsed
 * URLSearchParams instance so this stays trivial to test.
 */
import type { CheckoutFormFieldId } from './api.js';

export interface QueryParamMappingLike {
  param: string;
  field: CheckoutFormFieldId;
}

export interface LookupPrefill {
  reference?: string;
  email?: string;
  name?: string;
}

export function applyMappings(
  mappings: QueryParamMappingLike[] | undefined,
  params: URLSearchParams,
): LookupPrefill {
  if (!mappings || mappings.length === 0) return {};
  const out: LookupPrefill = {};
  for (const m of mappings) {
    const raw = params.get(m.param);
    if (raw === null || raw === '') continue;
    switch (m.field) {
      case 'referenceNumber':
        out.reference = raw;
        break;
      case 'email':
        out.email = raw;
        break;
      case 'name':
        out.name = raw;
        break;
    }
  }
  return out;
}
